<template>
  <v-sheet class="d-flex align-center justify-left py-2 px-4 mb-4" rounded="lg">
    <span class="status text-body-small text-grey">
      Status: <strong :class="statusLower">{{ mqttStore.status }}</strong>
    </span>
    <v-icon :class="statusLower" end :icon="statusIcon" />
    <v-spacer />
    <span
      v-if="mqttStore.lastMessageTimestamp"
      class="text-body-small text-grey"
    >
      <b>Last Updated:</b> {{ humanDateShort(mqttStore.lastMessageTimestamp) }}
    </span>
  </v-sheet>
</template>

<script setup>
  import { humanDateShort } from '#xapp-core/helpers'
  import { useMqttStore } from '#xapp-core/mqtt'
  import { computed } from 'vue'

  const mqttStore = useMqttStore()

  const statusLower = computed(() => mqttStore.status?.toLowerCase())

  const statusIcon = computed(() =>
    statusLower.value === 'connected' ? 'mdi-check-circle' : 'mdi-close-circle'
  )
</script>

<style scoped>
  .status {
    text-align: center;
  }

  .connected {
    color: green;
  }

  .disconnected,
  .reconnecting,
  .error {
    color: red;
  }

  .connecting,
  .idle {
    color: orange;
  }
</style>
